import { render, staticRenderFns } from "./EndorsementContractInsuredAddress.vue?vue&type=template&id=40cb52d6"
import script from "./EndorsementContractInsuredAddress.vue?vue&type=script&lang=js"
export * from "./EndorsementContractInsuredAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports